import {
  createBrowserRouter,
  createRoutesFromElements,
  redirect,
  Route,
} from "react-router-dom";
import Reports from "../screens/reports/List";
import ReportView from "../screens/reports/View";
import VerificationRequests from "../screens/verificationRequests/List";
import VerificationRequestView from "../screens/verificationRequests/View";
import DashboardContainer from "../components/DashboardContainer";
import Welcome from "../screens/Welcome";
import Login from "../screens/Login";
import Users from "../screens/users/List";
import UserView from "../screens/users/View";
import CreateNotifications from "../screens/createNotifications/Form";
import Shows from "../screens/shows/List";
import ShowView from "../screens/shows/View";
import Settings from "../screens/settings/View";
import Matches from "../screens/matches/List";
import MatchCreate from "../screens/matches/Create";
import MatchView from "../screens/matches/View";
import MatchTeams from "../screens/matches/Teams";
import MatchLeagues from "../screens/matches/Leagues";
import RefundRequests from "../screens/refundRequests/List";
import RefundRequestView from "../screens/refundRequests/View";
import PayoutRequests from "../screens/payoutRequests/List";
import PayoutRequestView from "../screens/payoutRequests/View";
import Transactions from "../screens/transactions/List";
import DailyPollList from "../screens/dailyPoll/List";
import DailyPollCreate from "../screens/dailyPoll/Create";
import DailyPollView from "../screens/dailyPoll/View";
import Rewards from "../screens/rewards/List";
import RewardsConfig from "../screens/rewards/Config";

const isAuthenticatedGuard = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return redirect("/login");
  }

  return null;
};

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route element={<DashboardContainer />} loader={isAuthenticatedGuard}>
        <Route index element={<Welcome />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:id" element={<ReportView />} />
        <Route
          path="verification-requests"
          element={<VerificationRequests />}
        />
        <Route
          path="verification-requests/:id"
          element={<VerificationRequestView />}
        />
        <Route path="users" element={<Users />} />
        <Route path="users/:id" element={<UserView />} />
        <Route path="create-notifications" element={<CreateNotifications />} />
        <Route path="shows" element={<Shows />} />
        <Route path="shows/:id" element={<ShowView />} />
        <Route path="matches" element={<Matches />} />
        <Route path="matches/create" element={<MatchCreate />} />
        <Route path="matches/teams" element={<MatchTeams />} />
        <Route path="matches/leagues" element={<MatchLeagues />} />
        <Route path="matches/:id" element={<MatchView />} />
        <Route path="refund-requests" element={<RefundRequests />} />
        <Route path="refund-requests/:id" element={<RefundRequestView />} />
        <Route path="payout-requests" element={<PayoutRequests />} />
        <Route path="payout-requests/:id" element={<PayoutRequestView />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="daily-polls" element={<DailyPollList />} />
        <Route path="daily-polls/create" element={<DailyPollCreate />} />
        <Route path="daily-polls/:id" element={<DailyPollView />} />
        <Route path="rewards" element={<Rewards />} />
        <Route path="rewards/config" element={<RewardsConfig />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="login" element={<Login />} />
    </Route>,
  ),
);
